import { render, staticRenderFns } from "./Distributors.vue?vue&type=template&id=2828f1f0&scoped=true&"
import script from "./Distributors.vue?vue&type=script&lang=ts&"
export * from "./Distributors.vue?vue&type=script&lang=ts&"
import style0 from "./Distributors.vue?vue&type=style&index=0&id=2828f1f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2828f1f0",
  null
  
)

export default component.exports